import { h, Fragment as F } from 'preact'
import { useEffect, useState, useMemo } from 'preact/hooks';
import { createPortal } from 'preact/compat';
import formatDistance from 'date-fns/formatDistance';
import dayjs from "dayjs";
// import { Pagination } from '../pagination.js';
import { filterRegistrars } from './helper.js';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime)

const maxPerPage = 12;
export function SearchResultSuggestions({data, whois, domain}) {
  const [ currentPageNo, updatePageNo ] = useState(1);
  const [ filteredData, updateFilteredData ] = useState([]);
  const [ haveMore, updateStatus ] = useState(false)


  useEffect(() => {
    const firstBatch = (currentPageNo - 1) * maxPerPage;
    updateFilteredData(data?.slice(0, firstBatch + maxPerPage));
  }, [ data, currentPageNo ]);

  useEffect(() => {
    updateStatus((currentPageNo * maxPerPage) < data.length )
  }, [ filteredData ])

  const nextPage = (e) => {
    e.preventDefault();
    updatePageNo(page => page + 1 )
  }

  const domainMessage = document.getElementById('domainMessage');

  const HeaderInfo = () => {
    return (
      <F>
        <h1 class="font-semibold text-center" ><p class="text-grey3 inline">{domain}</p> is unavailable</h1>
        <article class='flex flex-col max-w-[1440px] px-[30px] sm:px-6 lg:px-8 mt-4 mx-auto'>
          <section class='flex flex-wrap justify-center mt-3 gap-4 md:ml-0 my-6'>
            <div class='flex flex-col  basis-[48%] lg:basis-1/5 gap-1 grow bg-grey justify-between rounded-tl-[30px] h-[120px] py-3 px-5'>
              <div class="text-2xl text-brandColor4 font-playfair">Registered</div>
              <div class="flex flex-col">
                <div class="text-right">{ dayjs(whois.CreationDate).format("MMM D, YYYY") }</div>
                <div class="text-right text-xs">{ dayjs(whois.CreationDate).fromNow() }</div>
              </div>
            </div>
            <div class='flex flex-col  basis-[48%] lg:basis-1/5 gap-1 grow justify-between bg-grey rounded-tl-[30px] h-[120px] py-3 px-5'>
              <div class="text-2xl text-brandColor4 font-playfair">Expires</div>
              <div class="flex flex-col">
                <div class="text-right">{ dayjs(whois.RegistryExpiryDate).format("MMM D, YYYY") }</div>
                <div class="text-right text-xs">In { dayjs(whois.RegistryExpiryDate).toNow(true) }</div>
              </div>
            </div>
            <div class='flex flex-col  basis-[48%] lg:basis-1/5 gap-1 grow bg-grey justify-between rounded-tl-[30px] h-[120px] py-3 px-5'>
              <div class="text-2xl text-brandColor4 font-playfair">Updated</div>
              <div class="flex flex-col">
                <div class="text-right">{ dayjs(whois.UpdatedDate).format("MMM D, YYYY") }</div>
                <div class="text-right text-xs">{ dayjs(whois.UpdatedDate).fromNow() }</div>
              </div>
            </div>
            <div class='flex flex-col basis-[48%] lg:basis-1/5 gap-1 grow bg-grey justify-between rounded-tl-[30px] h-[120px] py-3 px-5'>
              <div class="font-playfair text-2xl text-brandColor4">Registrar</div>
              <div class="text-right">
                <a href={whois.RegistrarURL} target="_blank">{whois.Registrar}</a>
              </div>
            </div>
            {/* <div class='flex flex-col basis-full md:basis-1/2 lg:basis-1/5 grow content-none invisible'></div>
            <div class='flex flex-col basis-full md:basis-1/2 lg:basis-1/5 grow content-none invisible'></div>
            <div class='flex flex-col basis-full md:basis-1/2 lg:basis-1/5 grow content-none invisible'></div>
            <div class='flex flex-col basis-full md:basis-1/2 lg:basis-1/5 grow content-none invisible'></div>
            <div class='flex flex-col basis-full md:basis-1/2 lg:basis-1/5 grow content-none invisible'></div> */}
          </section>
        </article>
        {whois?.Raw && <section class="mb-4 container hs-accordion-group">
          <div class="hs-accordion mx-auto mb-3 max-w-[896px] border border-solid border-grey3 rounded-[20px] sm:rounded-[25px]" id="hs-basic-heading-{{loop.index}}">
            <button class="hs-accordion-toggle w-full text-left bg-white py-3 px-7 rounded-[20px] sm:rounded-[25px] bg-transparent inline-flex items-center justify-between" aria-controls="hs-basic-collapse-heading">
            {/* <button type="button" class="hs-collapse-toggle bg-black text-white text-lg px-2 sm:px-4 py-2 w-full" id="hs-unstyled-collapse" data-hs-collapse="#hs-unstyled-collapse-heading"> */}
              Show All WHOIS Information
              <svg class="hs-accordion-active:rotate-180 text-brandColor block rotate-0" xmlns="http://www.w3.org/2000/svg" width="18" height="11" viewBox="0 0 18 11">
                <path d="M17.6277 3.03445C18.1241 2.5381 18.1241 1.73336 17.6277 1.23701C17.1314 0.740658 16.3266 0.740659 15.8303 1.23701L9 8.0673L2.16971 1.23701C1.67336 0.740658 0.868612 0.740658 0.372261 1.23701C-0.124088 1.73336 -0.124088 2.5381 0.372263 3.03445L8.10128 10.7635C8.59763 11.2598 9.40237 11.2598 9.89872 10.7635L17.6277 3.03445Z" fill="#FD5A1F"/>
              </svg>
            </button>
            <div id="hs-basic-collapse-{{loop.index}}" class="hs-accordion-content rounded-[20px] sm:rounded-b-[25px] border-t-0 hidden overflow-hidden ease-linear transition-[height] duration-[.1s] bg-white" aria-labelledby="hs-basic-heading-collapse">
            {/* <div id="hs-unstyled-collapse-heading" class="hs-collapse hidden w-full overflow-hidden transition-[height] duration-300 p-2 sm:px-12 sm:py-8 border border-solid" aria-labelledby="hs-unstyled-collapse"> */}
              <div class="py-3 px-7">{
                whois?.Raw?.split('\r\n').map(d => 
                    d !== '' ? <div>{d}</div> : <br/>
                )}
              </div>
            </div>
          </div>
        </section>}
      </F>
    )
  }

  return (
    <section class="px-[30px]">
      {createPortal(<HeaderInfo />, domainMessage)}
      <h3 class="text-center text-[1.42rem] leading-6 mb-6 font-playfair text-brandColor4">Here are some great alternatives</h3>
      <div class='grid md:grid-cols-2 lg:grid-cols-3 gap-4'>
        {
          filteredData.map((spinner) => {
            return (
                <a class="border border-grey3 rounded-full inline-flex items-center text-default bg-white pl-7 pr-3 py-5 rounded-[100px] relative" href={`/getdomain/${spinner.Domain}`} key={spinner.Domain}>
                  {spinner.Domain}
                  {spinner.premium && <img class="ml-3" src="/assets/premium.svg"/>
                  }
                  <svg width="18" height="18" viewBox="0 0 18 18"  fill="#fd5a1f" class="ml-7 absolute right-3" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.16971 0.372264C1.67336 -0.124087 0.868614 -0.124088 0.372263 0.372263C-0.124088 0.868614 -0.124087 1.67336 0.372264 2.16971L7.20255 9L0.372263 15.8303C-0.124088 16.3266 -0.124088 17.1314 0.372263 17.6277C0.868614 18.1241 1.67336 18.1241 2.16971 17.6277L9.89872 9.89872C10.3951 9.40237 10.3951 8.59763 9.89872 8.10128L2.16971 0.372264Z" fill="#FD5A1F"/>
                  </svg>
                </a>
            )
          })
        }
      </div>
      <div class="flex justify-center mt-4">
        {
          // <Pagination currentPageNo={currentPageNo} onChangePage={updatePageNo} totalNoOfPage={Math.ceil(data.length / maxPerPage)}/>
          haveMore && <a class="bg-brandColor inline-flex items-center  pl-7 pr-3 py-3 text-white rounded-[100px]" onClick={nextPage} target="_blank" >
              Load more
              <svg width="18" height="18" viewBox="0 0 18 18"  fill="#fff" class="ml-7 mt-3 mr-3 rotate-90" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.16971 0.372264C1.67336 -0.124087 0.868614 -0.124088 0.372263 0.372263C-0.124088 0.868614 -0.124087 1.67336 0.372264 2.16971L7.20255 9L0.372263 15.8303C-0.124088 16.3266 -0.124088 17.1314 0.372263 17.6277C0.868614 18.1241 1.67336 18.1241 2.16971 17.6277L9.89872 9.89872C10.3951 9.40237 10.3951 8.59763 9.89872 8.10128L2.16971 0.372264Z" />
              </svg>
            </a>
        }
      </div>
    </section>
  )
}